import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import mediaQuery from "../abstract/media-query";
import globals from "../partials/global-variables";
import stylesConfig from "../styles.config";

const focusOutlineColor = stylesConfig.colors.primary.spectrum400;
export default {
  container: {
    "& .answers-wrapper": {
      display: "flex",
      flexFlow: "wrap row",
      justifyContent: "center",
      [`@media (${globals.breakpoints.$xs})`]: {
        flexFlow: "wrap column",
      },
      "& .answer": {
        cursor: "pointer",
        position: "relative",
        margin: [0, "7px", "20px"],
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "100% !important",
          margin: [0, 0, "15px"],
        },
        [mediaQuery.hover]: {
          "&:hover": {
            borderColor: stylesConfig.colors.primary.spectrum400,
          },
        },
        "&:focus": {
          outlineColor: focusOutlineColor,
        },
        "&.is-disabled:hover": {
          cursor: "default",
          borderColor: stylesConfig.colors.secondary.spectrum100,
        },
      },
      "& .answer-image": {
        position: "relative",
        height: "250px",
        [`@media (${globals.breakpoints.$xs})`]: {
          width: "100%",
          height: "100px",
        },
      },
      "& .fullRow": {
        "& .answer-image": {
          height: "180px",
          [`@media (${globals.breakpoints.$xs})`]: {
            height: "100px",
          },
        },
      },
      "&.checkbox": {
        "& .answer-icon-wrapper": {
          "& .answer-icon": {
            borderRadius: "6px",
            "&:after": {
              backgroundColor: "transparent",
              backgroundImage: (configuration: ResolvedComponentsConfiguration): string =>
                `${globals.customerSpriteTheme5(configuration)}`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "-40px -63px",
              width: "35px",
              height: "35px",
              top: 0,
              left: 0,
              [`@media (${globals.breakpoints.$xs})`]: {
                width: "20px",
                height: "20px",
                backgroundPosition: "-47px -71px",
              },
            },
          },
        },
      },
    },
    ".multi-answer &": {
      "& .question-type-hint": {
        display: "none",
      },
    },
  },
};
